import controlReducer from './controlReducer.js';
import { combineReducers } from 'redux';
import themeReducer from './themeReducer.js';
import riskReducer from './riskReducer.js';
import contextReducer from './contextReducer.js';
import cloudModelReducer from './cloudModelsReducer.js';
import configReducer from './configReducer.js';
import complianceReducer from './complianceReducer.js';
import residualRiskReducer from './residualRiskReducer.js';
import monitorsReducer from './monitorsReducer.js'
import riskScenariosReducer from './riskScenariosReducer.js'
import reviewsReducer from './reviewsReducer.js';
import templatesReducer from './templatesReducer.js';
import globalConfigsReducer from './globalConfigsReducer.js';

// New Redux Toolkit slices (assessment-centric architecture)
import assessmentsReducer from '../slices/assessmentsSlice.js';
import assessmentProgressReducer from '../slices/assessmentProgressSlice.js';
import risksSliceReducer from '../slices/risksSlice.js';
import riskSourcesReducer from '../slices/riskSourcesSlice.js';
import riskEvaluationsReducer from '../slices/riskEvaluationsSlice.js';
import riskScenariosSliceReducer from '../slices/riskScenariosSlice.js';
import modelsReducer from '../slices/modelsSlice.js';
import appReducer from '../slices/appSlice.js';
import residualRiskRTKReducer from '../slices/residualRiskSlice.js';
import reviewReducer from '../slices/reviewSlice.js';
import securityReducer from '../slices/securitySlice.js';
import promptsReducer from '../slices/promptsSlice.js';
import agentsReducer from '../slices/agentsSlice.js';

// Agency slices (Huginn Agency / Lambda)
import agencyAssessmentsReducer from '../../agency/redux/slices/agencyAssessmentsSlice.js';
import agencyFindingsReducer from '../../agency/redux/slices/agencyFindingsSlice.js';
import agencyAgentsReducer from '../../agency/redux/slices/agencyAgentsSlice.js';
import agencySkillsReducer from '../slices/agencySkillsSlice.js';
import agencyMethodsReducer from '../slices/agencyMethodsSlice.js';


const rootReducer = combineReducers({
    // New Redux Toolkit slices (assessment-centric)
    assessments: assessmentsReducer,
    assessmentProgress: assessmentProgressReducer,
    riskItems: risksSliceReducer,
    riskSources: riskSourcesReducer,
    riskEvaluations: riskEvaluationsReducer,
    riskScenarioItems: riskScenariosSliceReducer,
    models: modelsReducer,
    app: appReducer,
    residualRiskRTK: residualRiskRTKReducer,
    review: reviewReducer,
    security: securityReducer,
    prompts: promptsReducer,
    agents: agentsReducer,

    // Agency slices (Huginn Agency / Lambda)
    agencyAssessments: agencyAssessmentsReducer,
    agencyFindings: agencyFindingsReducer,
    agencyAgents: agencyAgentsReducer,
    agencySkills: agencySkillsReducer,
    agencyMethods: agencyMethodsReducer,

    // Legacy reducers (model-centric) - kept for backward compatibility
    themes: themeReducer,
    risks: riskReducer,
    riskScenarios: riskScenariosReducer,
    controls: controlReducer,
    compliance:complianceReducer,
    context: contextReducer,
    cloudModels:cloudModelReducer,
    config:configReducer,
    residualRisk:residualRiskReducer,
    monitors: monitorsReducer,
    reviews: reviewsReducer,
    templates: templatesReducer,
    globalConfigs: globalConfigsReducer,

});

export default rootReducer;
